import { from } from "rxjs";
import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { Router, ActivatedRoute } from "@angular/router";
import {
  HttpClient,
  HttpParams,
  HttpRequest,
  HttpHeaders,
} from "@angular/common/http";
import { environment } from "./../../../environments/environment";
import { ApiHelper } from "./../../_helpers/api.helper";
import { CommonHelper } from "./../../_helpers/common.helper";
import { AppConfig } from "./../../../app/app.config";
import { ConstantHelper } from "./../../_helpers/constant.helper";
import { UserService } from "./../../_services/user.service";
import { UploadService } from "./../../_services/upload.service";
import { SweetAlertHelper } from "src/app/_helpers/sweet.alert.helper";
import { Message } from "src/app/_locale/message";
import { async } from "@angular/core/testing";
import { Location } from '@angular/common';
@Component({
  selector: "app-email2user",
  templateUrl: "./email2user.component.html",
  styleUrls: ["./email2user.component.scss"],
  providers: [AppConfig, CommonHelper],
})
export class Email2userComponent implements OnInit {
  @ViewChild("fileUploaded1", { static: false }) fileUploaded1: ElementRef;
  @ViewChild("fileUploaded2", { static: false }) fileUploaded2: ElementRef;
  @ViewChild("fileUploaded3", { static: false }) fileUploaded3: ElementRef;
  showLoader = false;

  maxChars = 300;
  fileDesTxt: any = "";
  emailSubject: any = "";
  childRoute: string;
  loggedInUserId: string;
  patientId: string;
  patientObj: any = {};
  companySlug: string = ConstantHelper.COMPANY_SLUG;
  comapnyName: string = ConstantHelper.COMPANY_NAME;
  fileToUpload1: File = null;
  fSize1: any;
  fileToUpload2: File = null;
  fSize2: any;
  fileToUpload3: File = null;
  fSize3: any;

  httpHeaders = new HttpHeaders({
    "Content-Type": "application/json",
  });
  httpOptions = {
    headers: this.httpHeaders,
  };

  selectedDelegateId: any;
  assignedDelegateId: any;
  isDelegated: any = 0;
  message = Message;
  constructor(
    public commonHelper: CommonHelper,
    private appConfig: AppConfig,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    public sweetAlertHelper: SweetAlertHelper,
    public userService: UserService,
    public uploadService: UploadService,
    private location: Location
  ) {
    localStorage.setItem("childRoute", activatedRoute.snapshot.url[0].path);
    this.childRoute = activatedRoute.snapshot.url[0].path;

    this.loggedInUserId =
      this.activatedRoute.snapshot.paramMap.get("loggedInUserId");
    this.patientId = this.activatedRoute.snapshot.paramMap.get("patientId");
    this.selectedDelegateId = localStorage.getItem("delegateId")
      ? localStorage.getItem("delegateId")
      : this.loggedInUserId;

    this.findUserDetails(this.patientId);
  }

  ngOnInit() {}

  async onReset() {
    // if (
    //   confirm(
    //     "PLEASE CONFIRM: Are you certain you want to return to the Home Page?"
    //   )
    // )
    // const alertStatus = await this.sweetAlertHelper.confirmPopUp(
    //   this.message.confirmTitle,
    //   this.message.confirmMessages.adminChangePassComp.onReset
    // );
    // if (alertStatus) {
      this.router.navigate([
        "/" + this.childRoute + "/dashboard/" + this.loggedInUserId,
      ]);
    // }
  }
  async goToDemographics() {
    // if (
    //   confirm(
    //     "PLEASE CONFIRM: Are you certain you want to return to the User Database?"
    //   )
    // )
    // const alertStatus = await this.sweetAlertHelper.confirmPopUp(
    //   this.message.confirmTitle,
    //   this.message.confirmMessages.adminUploaddocComp.gotoDemgraphics
    // );
    // if (alertStatus) {
      // this.router.navigate([
      //   "/" + this.childRoute + "/demographics/" + this.loggedInUserId,
      // ]);
    // }

    this.location.back();
  }

  findUserDetails(userId) {
    const finalData = {
      id: userId,
    };
    this.showLoader = true;

    this.http
      .post(
        this.appConfig.getLambdaUrl05() + ApiHelper.name_findUserDetailsApi,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (res: any) => {
          this.patientObj = res.commandResult.data.userInfo;
          this.showLoader = false;
        },
        (err) => {
          // console.log(err);
        }
      );
  }

  checkDelegateStatus() {
    this.selectedDelegateId = localStorage.getItem("delegateId")
      ? localStorage.getItem("delegateId")
      : this.loggedInUserId;
    // console.log(this.selectedDelegateId);
    if (this.selectedDelegateId != this.loggedInUserId) {
      this.loggedInUserId = this.selectedDelegateId;
      this.assignedDelegateId =
        this.activatedRoute.snapshot.paramMap.get("loggedInUserId");

      this.isDelegated = 1;
    } else {
      this.loggedInUserId =
        this.activatedRoute.snapshot.paramMap.get("loggedInUserId");
    }
  }

  onFileSelected1(event) {
    if (this.fileUploaded1.nativeElement.value != "") {
      this.fileToUpload1 = event.target.files.item(0) as File;
      this.fSize1 = Math.round(this.fileToUpload1.size / 1024);
    } else {
    }
  }

  onFileSelected2(event) {
    if (this.fileUploaded2.nativeElement.value != "") {
      this.fileToUpload2 = event.target.files.item(0) as File;
      this.fSize2 = Math.round(this.fileToUpload2.size / 1024);
    } else {
    }
  }

  onFileSelected3(event) {
    if (this.fileUploaded3.nativeElement.value != "") {
      this.fileToUpload3 = event.target.files.item(0) as File;
      this.fSize3 = Math.round(this.fileToUpload3.size / 1024);
    } else {
    }
  }

  validateFile(name: String) {
    const ext = name.substring(name.lastIndexOf(".") + 1);
    if (
      ext.toLowerCase() == "png" ||
      ext.toLowerCase() == "jpg" ||
      ext.toLowerCase() == "jpeg" ||
      ext.toLowerCase() == "pdf"
    ) {
      return true;
    } else {
      return false;
    }
  }

  async onSubmit() {
    this.checkDelegateStatus();

    if (
      this.fileUploaded1.nativeElement.value != "" &&
      !this.validateFile(this.fileToUpload1.name)
    ) {
      // alert("Selected file 1 format is not supported");
      const alertStatus = await this.sweetAlertHelper.alertPopUp(
        this.message.alertMessages.adminsecondoptwfCOmp.d2d1_4
      );
      return false;
    } else if (
      this.fileUploaded1.nativeElement.value != "" &&
      this.fSize1 > 61440
    ) {
      // alert("File 1 too Big, please select a file less than 60mb");
      const alertStatus = await this.sweetAlertHelper.alertPopUp(
        this.message.alertMessages.adminsecondoptwfCOmp.d2d04_1
      );
      return false;
    } else if (
      this.fileUploaded2.nativeElement.value != "" &&
      !this.validateFile(this.fileToUpload2.name)
    ) {
      // alert("Selected file 2 format is not supported");
      const alertStatus = await this.sweetAlertHelper.alertPopUp(
        this.message.alertMessages.adminsecondoptwfCOmp.d2d1_4
      );
      return false;
    } else if (
      this.fileUploaded2.nativeElement.value != "" &&
      this.fSize2 > 61440
    ) {
      // alert("File 2 too Big, please select a file less than 60mb");
      const alertStatus = await this.sweetAlertHelper.alertPopUp(
        this.message.alertMessages.adminsecondoptwfCOmp.d2d04_3
      );
      return false;
    } else if (
      this.fileUploaded3.nativeElement.value != "" &&
      !this.validateFile(this.fileToUpload3.name)
    ) {
      // alert("Selected file 3 format is not supported");
      const alertStatus = await this.sweetAlertHelper.alertPopUp(
        this.message.alertMessages.adminsecondoptwfCOmp.d2d1_4
      );
      return false;
    } else if (
      this.fileUploaded3.nativeElement.value != "" &&
      this.fSize3 > 61440
    ) {
      // alert("File 3 too Big, please select a file less than 60mb");
      const alertStatus = await this.sweetAlertHelper.alertPopUp(
        this.message.alertMessages.adminsecondoptwfCOmp.d2d04_5
      );
      return false;
    } else {
      // if (
      //   confirm("Are you certain you want to send an email to this patient?")
      // )
      const alertStatus = await this.sweetAlertHelper.confirmPopUp(
        this.message.confirmTitle,
        this.message.confirmMessages.demographicsComp.email2All
      );
      if (alertStatus) {
        {
          this.showLoader = true;

          this.uploadService
            .sendMailToUser(
              this.loggedInUserId,
              this.emailSubject,
              this.fileDesTxt,
              this.patientId,
              this.fileToUpload1,
              this.fileToUpload2,
              this.fileToUpload3,
              this.assignedDelegateId,
              this.isDelegated,
              this.selectedDelegateId
            )
            .subscribe(
              async (data: any) => {
                if (data !== undefined) {
                  // alert("Email successfully sent to the patient.");
                  this.showLoader = false;
                  const alertStatus = await this.sweetAlertHelper.alertPopUp(
                    this.message.alertMessages.adminsecondoptwfCOmp.d2d04_9
                  );
                  if (alertStatus) {
                    this.router.navigate([
                      "/" +
                        this.childRoute +
                        "/demographics/" +
                        localStorage.getItem("loggedInUserId") +
                        "/" +
                        0,
                    ]);
                    this.location.back();
                  }
                  // window.location.reload();
                }
                this.showLoader = false;
                // window.location.reload();
              },
              (error) => {
                // console.log(error);
              }
            );
        }
      }
    }
  }
}
